import { css } from '@emotion/css';

export const asyncMultiSelectopperStyles = css`
  .MuiCheckbox-root {
    border-radius: 0.4rem;
  }

  .MuiPaper-root:empty {
    opacity: 0;
  }
`;
